<template>
  <div class="login-wrapper">
    <div class="login-view">
      <div class="login-main">
        <before-login
          v-if="showBeforeLogin"
          @getChoiceType="getChoiceType"
        ></before-login>
        <div class="login-content" v-if="showLoginContent && !showBeforeLogin">
          <div class="login-logo"></div>
          <div class="input-group">
            <el-input
              v-if="userType == 1"
              placeholder="请输入手机号"
              id="username"
              v-model="loginData.mobile"
            >
              <template slot="prepend"
                ><i class="iconfont icon-username"></i
              ></template>
            </el-input>
            <el-input
              v-else
              placeholder="请输入手机号"
              id="username"
              v-model="loginData.name"
            >
              <template slot="prepend"
                ><i class="iconfont icon-username"></i
              ></template>
            </el-input>
          </div>
          <div class="input-group">
            <el-input
              type="password"
              placeholder="请输入密码"
              id="password"
              v-model="loginData.password"
            >
              <template slot="prepend"
                ><i class="iconfont icon-password"></i
              ></template>
            </el-input>
          </div>
          <div
            class="input-group"
            style="display: flex"
            v-if="showChildValidation"
          >
            <el-input
              v-model="loginData.code"
              :class="verifyErrorIp && 'is-invalid'"
              placeholder="短信验证码"
            ></el-input>
            <el-button
              v-if="!sendingCode"
              type="primary"
              class="btn-send-code"
              @click="sendCode(loginData.name, (type = 12))"
              >获取验证码</el-button
            >
            <countdown
              v-else
              :time="59000"
              tag="el-button"
              v-on:countdownend="onCountdownEndCode"
              ref="countdownIp"
              disabled="disabled"
              class="el-button--primary btn-send-code"
            >
              <template slot-scope="props"
                >{{ props.seconds }} 秒后重新发送</template
              >
            </countdown>
          </div>

          <div class="input-group" style="display: flex" v-if="showLoginIp">
            <el-input
              v-model="loginData.code"
              :class="verifyErrorIp && 'is-invalid'"
              placeholder="短信验证码"
            ></el-input>
            <el-button
              v-if="!sendingIp"
              type="primary"
              class="btn-send-code"
              @click="sendCode(loginData.mobile, (type = 6))"
              >获取验证码</el-button
            >
            <countdown
              v-else
              :time="59000"
              tag="el-button"
              v-on:countdownend="onCountdownEndIP"
              ref="countdownIp"
              disabled="disabled"
              class="el-button--primary btn-send-code"
            >
              <template slot-scope="props"
                >{{ props.seconds }} 秒后重新发送</template
              >
            </countdown>
          </div>
          <a
            href="javascript:;"
            class="forget-passwd"
            @click="forgetPasswd"
            v-if="userType == 1"
            >忘记密码 ?</a
          >
          <div class="input-group submit-btn">
            <el-button type="primary" id="login" @click="seletLogin"
              >登录</el-button
            >
          </div>
        </div>
        <div
          class="forget-password-content"
          v-if="!showLoginContent && !showBeforeLogin"
        >
          <div class="login-logo"></div>
          <div class="input-group">
            <el-input
              placeholder="请输入手机号"
              id="username"
              v-model="forgetPasswdData.mobile"
            >
              <template slot="prepend"
                ><i class="iconfont icon-username"></i
              ></template>
            </el-input>
          </div>
          <div class="input-group">
            <el-input
              placeholder="请输入新密码"
              type="password"
              id="password"
              v-model="forgetPasswdData.password"
            >
              <template slot="prepend"
                ><i class="iconfont icon-password"></i
              ></template>
            </el-input>
          </div>
          <div class="input-group" style="display: flex">
            <el-input
              v-model="forgetPasswdData.code"
              :class="verifyError && 'is-invalid'"
              placeholder="短信验证码"
            ></el-input>
            <el-button
              v-if="!sending"
              type="primary"
              class="btn-send-code"
              @click="sendCode(forgetPasswdData.mobile, (type = 7))"
              >获取验证码</el-button
            >
            <countdown
              v-else
              :time="59000"
              tag="el-button"
              v-on:countdownend="onCountdownEnd"
              ref="countdown"
              disabled="disabled"
              class="el-button--primary btn-send-code"
            >
              <template slot-scope="props"
                >{{ props.seconds }} 秒后重新发送</template
              >
            </countdown>
          </div>
          <a href="javascript:;" class="back-login" @click="backLogin"
            >返回登录</a
          >

          <div class="input-group submit-btn">
            <el-button type="primary" id="reset" @click="reset"
              >重置密码</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.login-wrapper {
  width: 100%;
  height: 100vh;
  background: url("../../assets/background.jpg") no-repeat;
  background-size: cover;
  min-height: 650px;
  position: relative;
  .submit-btn {
    position: absolute;
    left: 0;
    bottom: 30px;
    padding: 0 45px;
    width: 100%;
  }
  .btn-send-code {
    margin-left: 16px;
  }
  .el-input-group__prepend {
    padding-top: 3px;
  }
  .iconfont {
    font-size: 14px;
    color: #e0e2e5;
  }
  .login-view {
    height: 550px;
    background: #333;
    width: 386px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    box-shadow: -6px 10px 30px 0 rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 10px;
    .login-main {
      background: #fff;
      border-radius: 10px;
      position: absolute;
      z-index: 10;
      width: 386px;
      top: 0;
      bottom: 0;
      right: 0;
      text-align: center;
      transition: all 0.8s linear;
      overflow: hidden;
      .loginfade-transition {
        z-index: 100;
      }
      .login-content,
      .forget-password-content {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        padding: 70px 45px 0 45px;
        background: #fff;
        .el-input__inner {
          height: 46px;
        }
        .login-logo {
          width: 150px;
          height: 38px;
          margin: 0 auto 66px;
          background: url("../../assets/logo.jpg") no-repeat;
          background-position: 0 0;
          background-size: contain;
        }
        .input-group {
          box-sizing: border-box;
          margin-bottom: 16px;
        }
      }
      .forget-passwd,
      .back-login {
        display: block;
        color: #969696;
        cursor: pointer;
        font-size: 12px;
        text-align: left;
      }
      .login-content {
        #login {
          display: block;
          width: 296px;
          margin: 0 auto;
          height: 48px;
        }
      }
      .forget-password-content {
        .btn-send-code {
          margin-left: 16px;
        }
        #reset {
          display: block;
          width: 100%;
          margin: 24px auto 0;
          height: 48px;
        }
      }
    }
    &.forget-login-view {
      .login-main {
        right: 383px;
      }
      .login-bg {
        left: 663px;
        background-position: -663px 0;
      }
    }
  }
}
</style>

<script>
import countdown from "@xkeshi/vue-countdown";
import md5 from "@/js/common/md5";
import beforeLogin from "@/views/pages/beforeLogin";
export default {
  name: "Login",
  data() {
    return {
      showChildValidation: false,
      showBeforeLogin: true,
      userType: "",
      showLoginIp: false,
      sendingIp: false,
      sendingCode: false,
      verifyErrorIp: false,
      nameError: false,
      passwordError: false,
      verifyError: false,
      sending: false,
      showLoginContent: true,
      loginData: {
        mobile: "",
        password: "",
        biz_code: "",
        name: "",
        code: ""
      },
      forgetPasswdData: {
        mobile: "",
        password: "",
        code: ""
      },
      isLeftIn: false,
      isRightIn: false,
      isForgetLoginView: false
    };
  },
  mounted() {
    lib.storage.rm("appKey");
    lib.storage.rm("appPwd");
    this.loginData.biz_code =
      this.$route.query.biz_code || lib.storage.get("biz_code");
    lib.storage.set("biz_code", this.loginData.biz_coe);
  },

  methods: {
    getChoiceType(type) {
      this.userType = type;
      lib.storage.set("userType", type);
      this.showBeforeLogin = false;
    },
    showTitleContentRight() {
      setTimeout(() => {
        this.isLeftIn = true;
      }, 400);
    },
    showTitleContentLeft() {
      setTimeout(() => {
        this.isRightIn = true;
      }, 400);
    },
    // 忘记密码
    forgetPasswd() {
      this.$toast("请联系技术部-余杰（夜鹰）！");
      // this.isLeftIn = false;
      // this.isForgetLoginView = true;
      // setTimeout(() => {
      //   this.showLoginIp = false
      //   this.sendingIp = false
      //   this.loginData.code = ''
      //   this.showLoginContent = false;
      //   this.showTitleContentLeft();
      // }, 400);
    },

    // 返回登陆
    backLogin() {
      this.isRightIn = false;
      this.isForgetLoginView = false;
      setTimeout(() => {
        this.forgetPasswdData.code = "";
        this.sending = false;
        this.showLoginContent = true;
        this.showTitleContentRight();
      }, 400);
    },
    seletLogin() {
      this.goLogin();
    },
    // 登录
    goLogin() {
      delete this.loginData.name;
      if (this.isAjax) return;
      this.isAjax = true;
      let validated = this._loginValidate();
      let that = this;
      lib.api.isWaiting = false;
      if (validated.success) {
        lib.tmsapi.post({
          api: "api/test/user/login",
          data: {
            phone_number: that.loginData.mobile,
            password: that.loginData.password
          },
          success: res => {
            lib.login.login(res.data);
          },
          error: data => {
            that.$message.error(data.error.msg);
            console.log(data);
          },
          complete: () => {}
        });
      } else {
        this.$message.error(validated.msg);
        this.isAjax = false;
      }
    },

    sendCode(mobile, type) {
      if (!/^[0-9]{11}$/.test(mobile)) {
        this.$message.error("手机号格式不正确");
      } else {
        lib.api.post({
          api: "ec/c/message/mobile/code/send",
          data: {
            scene: 1, // 发送验证码类型1短信 2语音，默认1
            type: type,
            mobile: mobile
          },
          success: data => {
            if (type === 6) {
              this.$nextTick(() => {
                this.sendingIp = true;
              });
            } else if (type === 12) {
              this.$nextTick(() => {
                this.sendingCode = true;
              });
            } else {
              this.$nextTick(() => {
                this.sending = true;
              });
            }
          },
          error: data => {
            if (data && data.msg) {
              this.$message.error(data.msg);
            } else {
              this.$message.error("短信发送失败，请重试");
            }
            if (type === 6) {
              this.$nextTick(() => {
                this.sendingIp = false;
              });
            } else if (type === 12) {
              this.$nextTick(() => {
                this.sendingCode = false;
              });
            } else {
              this.$nextTick(() => {
                this.sending = false;
              });
            }
          }
        });
      }
    },

    onCountdownEnd() {
      this.sending = false;
    },
    onCountdownEndIP() {
      this.sendingIp = false;
    },
    onCountdownEndCode() {
      this.sendingCode = false;
    },

    // 登陆判断逻辑
    _loginValidate() {
      // 校验
      if (this.userType === 2) {
        if (!this.loginData.name) {
          this.nameError = true;
          return {
            success: false,
            msg: "登录账号不能为空"
          };
        }
        if (!/^[0-9]{11}$/.test(this.loginData.name)) {
          this.nameError = true;
          return {
            success: false,
            msg: "登录账号格式不正确"
          };
        }
      } else {
        if (!this.loginData.mobile) {
          this.nameError = true;
          return {
            success: false,
            msg: "手机号不能为空"
          };
        }
        if (!/^[0-9]{11}$/.test(this.loginData.mobile)) {
          this.nameError = true;
          return {
            success: false,
            msg: "手机号格式不正确"
          };
        }
      }

      if (!this.loginData.password) {
        this.passwordError = true;
        return {
          success: false,
          msg: "密码不能为空"
        };
      }

      if (this.showLoginIp || this.showChildValidation) {
        if (!this.loginData.code) {
          this.verifyErrorIp = true;
          return {
            success: false,
            msg: "验证码不能为空"
          };
        }
        if (!/^[0-9]{6}$/.test(this.loginData.code)) {
          this.verifyErrorIp = true;
          return {
            success: false,
            msg: "请输入6位数的验证码"
          };
        }
      } else {
        return {
          success: true
        };
      }

      return {
        success: true
      };
    },
    // 忘记密码判断逻辑
    _forgetValidate() {
      // 校验
      if (!this.forgetPasswdData.mobile) {
        this.nameError = true;
        return {
          success: false,
          msg: "手机号不能为空"
        };
      }
      if (!/^[0-9]{11}$/.test(this.forgetPasswdData.mobile)) {
        this.nameError = true;
        return {
          success: false,
          msg: "手机号格式不正确"
        };
      }
      if (!this.forgetPasswdData.password) {
        this.passwordError = true;
        return {
          success: false,
          msg: "密码不能为空"
        };
      }
      if (!this.forgetPasswdData.code) {
        this.verifyError = true;
        return {
          success: false,
          msg: "验证码不能为空"
        };
      }
      if (!/^[0-9]{6}$/.test(this.forgetPasswdData.code)) {
        this.verifyError = true;
        return {
          success: false,
          msg: "请输入6位数的验证码"
        };
      }

      return {
        success: true
      };
    }
  },
  components: {
    countdown,
    beforeLogin
  }
};
</script>
